var render = function render(_c,_vm){return _c('div',[_vm._l((String(_vm.props.value).split('\n')),function(line,i){return [_vm._v("\n        "+_vm._s(line)),_c('br',{key:i})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }